import ProgressBar from 'components/ProgressBar';
import BudgetIsPendingWrap from 'components/projects/BudgetIsPendingWrapper';
import { Td } from 'components/ui-blocks/table/Td';
import React from 'react';
import type { Currency } from 'types/account';
import type { BudgetType } from 'types/project';
import { ViewportWidthBreakpoint } from 'utils/viewport';
import styles from '../TableWidget.module.scss';
import TableWidgetBudgetValueBlock from './TableWidgetBudgetValueBlock';

interface Props {
  columnKey?: number;
  currency?: Currency;
  currentWidthBreakpoint: ViewportWidthBreakpoint;
  progress?: number;
  type?: BudgetType;
  value?: number;
  pending?: boolean;
}

const TableWidgetBarCell: React.FC<Props> = ({
  columnKey,
  currency,
  currentWidthBreakpoint,
  progress,
  type,
  value,
  pending,
}) => {
  if (currentWidthBreakpoint < ViewportWidthBreakpoint.Medium) {
    return (
      <Td vertical columnKey={columnKey}>
        <TableWidgetBudgetValueBlock
          type={type}
          value={!value ? undefined : value}
          currency={currency}
          className={styles.pivotedBarValue}
        />
        <ProgressBar
          size="xsmall"
          value={pending ? undefined : progress}
          secondaryValue={pending ? 100 : undefined}
          secondaryProgressColor="#b4b9bf"
          animated
          className={styles.pivotedBar}
        />
      </Td>
    );
  }

  return (
    <>
      <Td style={{ width: '50%' }}>
        <ProgressBar
          size="xsmall"
          value={pending ? undefined : progress}
          secondaryValue={pending ? 100 : undefined}
          secondaryProgressColor="#b4b9bf"
          animated
          minWidth={50}
          rtl
        />
      </Td>
      <Td numeric>
        <BudgetIsPendingWrap
          tooltipPosition="left"
          title="Budget is being calculated..."
          isPending={!!pending}
        >
          <TableWidgetBudgetValueBlock
            type={type}
            value={!value ? undefined : value}
            currency={currency}
          />
        </BudgetIsPendingWrap>
      </Td>
    </>
  );
};

export default TableWidgetBarCell;
